import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import { SolidWarnButton } from 'components/buttons/SolidWarnButton';
import { OutlineButton } from 'components/buttons/OutlineButton';
import ModalContainer from 'components/ModalContainer';

const RemoveModal = ({ isOpenRemovalModal, selectedLdap, removeCallbacks }) => {
  const theme = useTheme();

  return (
    <ModalContainer display={isOpenRemovalModal} modalWidth="500px">
      <Box sx={{ padding: '0 10px', textAlign: 'center' }}>
        <Typography sx={{ color: theme.palette.primary.main, fontFamily: theme.typography.fontFamily, fontSize: theme.typography.customFontSize[5], fontWeight: theme.typography.customFontWeight[3], overflowWrap: 'anywhere', marginBottom: 1 }}>
          Remove Profile
        </Typography>

        <Typography>Are you sure you want to remove </Typography>
        <Typography sx={{ fontWeight: theme.typography.customFontWeight[1], wordBreak: 'break-word', textAlign: 'center', maxWidth: '100%' }}>
          "{selectedLdap?.name}"
          <Box component="span" sx={{ fontWeight: 'normal' }}>
            ?
          </Box>
        </Typography>

        <Box sx={{ marginTop: '20px', paddingTop: '20px', display: 'flex', justifyContent: 'center' }}>
          <OutlineButton sx={{ marginRight: '20px' }} width="100px" height="32px" onClick={() => removeCallbacks.removeCancel()}>Cancel</OutlineButton>
          <SolidWarnButton width="100px" height="32px" onClick={() => removeCallbacks.removeConfirm()}>Remove</SolidWarnButton>
        </Box>
      </Box>
    </ModalContainer>
  )
}

export default RemoveModal;
